const cookiesActionTypes = {
    COOKIES_MODAL_SHOW : 'COOKIES_MODAL_SHOW',
    COOKIES_MODAL_HIDE : 'COOKIES_MODAL_HIDE',
}

export default cookiesActionTypes
